import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, skipPasswordCheck = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span className="eyebrow" data-testid="auth-loading">Loading portal...</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  if (!skipPasswordCheck && user.must_change_password) return <Navigate to="/change-password" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/portal" replace />;
  return children;
}
